import Dashboard  from './pages/HomePage';
import NotFound from './pages/NotFound';
import SignIn  from './pages/Signin';
import Recover from './pages/ResetRequest';
import VerifyEmail from './pages/VerifyEmail';
import RestartPassword from './pages/RestartPassword';
import { Routes } from './routes';
import PrivateRoute from './utils/privateRoute';
// vendor styles
import "react-datetime/css/react-datetime.css";
// core styles
import "./scss/volt.scss";
import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory, useLocation } from "react-router-dom";
import HashLoader from "react-spinners/HashLoader";
import { ProvideAuth, useAuth } from "./hooks/auth.hook";
import SignUp from './pages/Signup';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ModalWrapperProvider } from "./components/ModalWrapperProvider"

const Loading = () => {
  const history = useHistory();
  // here goes the auth hook
  const auth = useAuth();
  let location = useLocation();
  let { from } = location.state || {from: { pathname: "/dashboard"}}

  useEffect(() => {
    if (auth?.user?.logged === false) {
      history.replace("/login");
    } else if (auth?.user?.logged === true) {
      history.replace(from);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user?.logged]);

  return (
    <div
      style={{
        background: "#FFFF",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          height: "100vh",
        }}
      >
        <HashLoader size={80} color={"#0063c3"} />
      </div>
    </div>
  );


}

const RouterComponent = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to={{ pathname: "/loading"}} />
        </Route>
        <Route path="/verify">
          <VerifyEmail></VerifyEmail>
        </Route>
        <Route path="/restart/account">
          <RestartPassword></RestartPassword>
        </Route>
        <Route path="/loading">
          <Loading />
        </Route>
        <PrivateRoute path={Routes.DashboardOverview.path}>
          <Dashboard/>
        </PrivateRoute>
        <PrivateRoute path={Routes.IBs.path}>
          <Dashboard />
        </PrivateRoute>
        <PrivateRoute path={Routes.Txs.path}>
          <Dashboard />
        </PrivateRoute>
        <PrivateRoute path={Routes.Clients.path}>
          <Dashboard/>
        </PrivateRoute>
        <PrivateRoute path={Routes.PermissionsAndReports.path}>
          <Dashboard/>
        </PrivateRoute>
        <Route path="/404">
          <NotFound />
        </Route>
        <Route path={Routes.Signup.path}>
          <SignUp></SignUp>
        </Route>
        <Route path={Routes.Signin.path}>
          <SignIn></SignIn>
        </Route>
        <Route path={Routes.RecoverAccount.path}>
          <Recover></Recover>
        </Route>
        <Route path="*">
          <Redirect to={{pathname: "/404"}}/>
        </Route>
      </Switch>
    </Router>
  )
}

const App = () => {
  return (
    // here add providers like the Auth provider
    <>
      <ProvideAuth>
      <ModalWrapperProvider>
        <ToastContainer></ToastContainer>
        <RouterComponent/>
      </ModalWrapperProvider>
      </ProvideAuth>
    </>
  )
}
export default App;